// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.receipt[data-v-23060dcc] {\n  width: 100%;\n  background-color: #fff;\n}\n.receipt__note-wrapper[data-v-23060dcc] {\n  padding: 10px;\n}\n.receipt__cancel-policy[data-v-23060dcc] {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
